/**
 *  * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'WriteOff',
    path: '/write-off/index',
    component: () =>
      import(/* webpackChunkName: "WriteOff" */ '@/views/write-off/index'),
    meta: { title: '注销账号' },
  },
  {
    name: 'WriteOffFeedBack',
    path: '/write-off/feedback',
    component: () =>
      import(
        /* webpackChunkName: "WriteOffFeedBack" */ '@/views/write-off/feedback'
      ),
    meta: { title: '注销账号' },
  },
  {
    name: 'WriteOffResult',
    path: '/write-off/result',
    component: () =>
      import(
        /* webpackChunkName: "WriteOffResult" */ '@/views/write-off/result'
      ),
    meta: { title: '注销账号' },
  },
  {
    name: 'WriteOffAuthCode',
    path: '/write-off/auth-code',
    component: () =>
      import(
        /* webpackChunkName: "WriteOffAuthCode" */ '@/views/write-off/authcode.vue'
      ),
    meta: { title: '' },
  },
  {
    name: 'WriteOffProtocol',
    path: '/write-off/protocol',
    component: () =>
      import(
        /* webpackChunkName: "WriteOffProtocol" */ '@/views/write-off/protocol.vue'
      ),
    meta: { title: '注销协议' },
  },
];
